import { type GetEventsQueryVariables } from "@package/ui-gql/index-analytics";
import type {
  GetLayoutGridQueryVariables,
  GetLocationGridQueryVariables,
  GetMediaGridQueryVariables,
  GetPostGridQueryVariables,
  GetProfileGridQueryVariables,
  GetTagGridQueryVariables,
} from "@package/ui-gql/index-data-access";
import {
  createSliceItemGrid,
  type SliceItemGridStateEntry,
} from "@package/ui-redux";
import moment from "moment";
import {
  ITEM_GRID_PER_PAGE_DEFAULT,
  SidebarEntryPath,
} from "../../constants/contants";
import { setSelectedParentIdHierarchy } from "./slice-media";

export type SliceItemGridState = {
  [SidebarEntryPath.events]: SliceItemGridStateEntry<GetEventsQueryVariables>;
  [SidebarEntryPath.layout]: SliceItemGridStateEntry<GetLayoutGridQueryVariables>;
  [SidebarEntryPath.locations]: SliceItemGridStateEntry<GetLocationGridQueryVariables>;
  [SidebarEntryPath.media]: SliceItemGridStateEntry<GetMediaGridQueryVariables>;
  [SidebarEntryPath.posts]: SliceItemGridStateEntry<GetPostGridQueryVariables>;
  [SidebarEntryPath.profiles]: SliceItemGridStateEntry<GetProfileGridQueryVariables>;
  [SidebarEntryPath.tags]: SliceItemGridStateEntry<GetTagGridQueryVariables>;
};

const defaultGridOptions = {
  filtersOpen: false,
  variables: {
    filter: {},
    page: 0,
    perPage: ITEM_GRID_PER_PAGE_DEFAULT,
    sortField: "name",
    sortOrder: "ASC",
  },
};
const initialState: SliceItemGridState = {
  events: {
    ...defaultGridOptions,
    variables: {
      ...defaultGridOptions.variables,
      filter: {
        ...defaultGridOptions.variables?.filter,
        range: {
          end: moment().add(7, "days").toDate(),
        },
      },
      sortField: "timestamp",
      sortOrder: "DESC",
    },
  },
  layout: defaultGridOptions,
  locations: defaultGridOptions,
  media: defaultGridOptions,
  posts: {
    ...defaultGridOptions,
    variables: {
      ...defaultGridOptions.variables,
      sortField: "title",
    },
  },
  profiles: defaultGridOptions,
  tags: {
    ...defaultGridOptions,
    variables: {
      ...defaultGridOptions.variables,
      sortField: "title",
    },
  },
};

const slice = createSliceItemGrid<SliceItemGridState>({
  initialState,
  extraReducers: (builder) => {
    builder.addCase(setSelectedParentIdHierarchy, (state) => {
      state[SidebarEntryPath.media].variables.page = 0;
    });
  },
});

export const {
  resetItemGridOptions,
  setItemGridFilter,
  setItemGridFilterOpen,
  setItemGridPage,
  setItemGridPerPage,
  setItemGridQuery,
  setItemGridSortField,
  setItemGridSortOrder,
  setItemGridSelectedItemId,
  setItemGridWithDeleted,
} = slice.actions;

export const reducerItemGrid = slice.reducer;
